import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { createNewUser, callCreateNewUser } from '../../actions'
import classNames from 'classnames';

const AddUserView = ({ status, createNewUser, onExitClicked, firstName, lastName, userName, permission, password, errorMessage, inputValidation }) => {
    function convertFormToJson(el){
        let o = {};
        $.each($(el).serializeArray(),function(){
            o[this.name] = this.value
        })
        return o;
    }

    const FailedDialog = ()=>{
        if( status === 'failed' ){
            return(
                <div className="alert alert-danger" role="alert">
                    <div className="alert-icon">
                        <svg className="cyclops-icon" aria-hidden="true"><use xlinkHref='#icon-minus-circle'/></svg>
                    </div>
                    <h4>Error</h4>
                    <p>User: {userName}. Status: {errorMessage}</p>
                </div>
            )
        }else{
            return null;
        }
    };

    const FetchingDialog = ()=>{
        if( status === 'fetching' ){
            return(
                <div className="alert alert-success" role="alert">
                    <div className="alert-icon">
                        <svg className="cyclops-icon" aria-hidden="true"><use xlinkHref='#icon-plus-circle'/></svg>
                    </div>
                    <h4>...</h4>
                    <p>Creating a new user ..</p>
                </div>
            )
        }else{
            return null;
        }
    };

    const SuccessDialog = () => {
        if ( status === 'succeed') {
            return(
                <div className="alert alert-success" role="alert">
                    <div className="alert-icon">
                        <svg className="cyclops-icon" aria-hidden="true"><use xlinkHref='#icon-plus-circle'/></svg>
                    </div>
                    <p>Your request to create user {userName} in Azure succeeded.</p>
                </div>
            )
        } else {
            return null;
        }
    };

    const ValidationDialog = () => {
        if ( !inputValidation.validated) {
            return(
                <div className="alert alert-danger" role="alert">
                    <div className="alert-icon">
                        <svg className="cyclops-icon" aria-hidden="true"><use xlinkHref='#icon-minus-circle'/></svg>
                    </div>
                    <p>Please fix the following validation errors and try again.</p>
                    <ul>
                        {inputValidation.messages.map(function(message){
                            return <li>{message}</li>;
                        })}
                    </ul>
                </div>
            )
        } else {
            return null;
        }
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <FailedDialog/>
                <FetchingDialog/>
                <SuccessDialog/>
                <ValidationDialog/>
                <div className={classNames("col-md-12", {'blockLoading': (status == 'fetching')})}>
                    <h2 className="header">{(status == 'fetching') ? "Creating User" : "Create User"}</h2>
                    <form id="addUserForm" className="form-horizontal col-md-12">

                        <div className="form-group">
                            <label htmlFor="addUser_cloudProvider" className="col-sm-2 control-label">Cloud</label>
                            <div className="col-sm-4">
                                <select className="form-control" name="cloudProviderDropDown" id="addUser_cloudProvider" disabled>
                                    <option value="Microsoft Azure" selected>Microsoft Azure</option>
                                </select>
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="AddUser_FirstName" className="col-sm-2 control-label">FirstName</label>

                            <div className="col-sm-4">
                                <input className="form-control" name="firstName" type="text" placeholder="FirstName" id="AddUser_FirstName" />
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="AddUser_LastName" className="col-sm-2 control-label">LastName</label>

                            <div className="col-sm-4">
                                <input className="form-control" name="lastName" type="text" placeholder="LastName" id="AddUser_LastName" />
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="AddUser_UserName" className="col-sm-2 control-label">UserName</label>

                            <div className="col-sm-4">
                                <input className="form-control" name="userName" type="text" placeholder="UserName" id="AddUser_UserName"  />
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="AddUser_Password" className="col-sm-2 control-label">Password</label>

                            <div className="col-sm-4">
                                <input className="form-control" name="password" type="password" placeholder="Password" id="AddUser_Password"  />
                                <br />
                                <div id="passwordRequirementsAlert" className="alert alert-info" role="alert">
                                    <div className="alert-icon">
                                        <svg className="cyclops-icon" aria-hidden="true"><use xlinkHref='#icon-info-circle'/></svg>
                                    </div>
                                    <p>Passwords must be a minimum of 8 characters and a maximum of 16 characters in length, and must contain at least three of the following:</p>
                                    <ul>
                                        <li>A lowercase letter a - z</li>
                                        <li>An uppercase letter A - Z</li>
                                        <li>A numeral 0 - 9</li>
                                        <li>Any of the special characters @ # $ % ^ & * - _ ! + = [ ] { } | \ : ' , . ? / ` ~ " ( ) ;</li>
                                    </ul>
                                </div>
                                <div id="passwordInfoAlert" className="alert alert-info" role="alert">
                                    <div className="alert-icon">
                                        <svg className="cyclops-icon" aria-hidden="true"><use xlinkHref='#icon-info-circle'/></svg>
                                    </div>
                                    <p>The username and password is not retrievable (we don't store your credentials). Please make sure to keep the credential information in a safe place.</p>
                                </div>
                            </div>
                            {
                            // Password strength will be added dynamically
                            }
                        </div>

                        <div className="form-group">
                            <label htmlFor="AddUser_Password" className="col-sm-2 control-label">Confirm Password</label>

                            <div className="col-sm-4">
                                <input className="form-control" name="passwordConfirm" type="password" placeholder="Confirm Password" id="AddUser_Password"  />
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="addUser_permission" className="col-sm-2 control-label">Permission</label>
                            <div className="col-sm-4">
                                <select className="form-control" name="permission" id="addUser_permission"  >
                                    <option value="global_administrator">Admin</option>
                                    <option value="reader" selected>Reader</option>
                                </select>
                            </div>
                        </div>

                        <div className="form-group form-submit addUserBtnGroup">
                            <button type="button" className="btn btn-primary" onClick={
                                (status)=>{
                                    // console.log(JSON.stringify($('#addUserForm').serializeArray()));
                                    createNewUser({
                                        formData: ( convertFormToJson($('#addUserForm')) ),
                                        status: 'validation'
                                    })
                                }
                            }>
                                Create User
                            </button>
                            <button type="button" className="btn btn-link" onClick={ ()=>{onExitClicked( )}}>
                                Cancel
                            </button>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    )
};

const mapStateToProps = ( state ) => ({
    status: state.createNewUserRed.status,
    firstName: state.createNewUserRed.firstName,
    lastName: state.createNewUserRed.lastName,
    permission: state.createNewUserRed.permission,
    password: state.createNewUserRed.password,
    formData: state.createNewUserRed.formData,
    data: state.createNewUserRed.data,
    inputValidation: state.createNewUserRed.inputValidation,
    userName: state.createNewUserRed.userName,
    errorMessage: state.createNewUserRed.errorMessage,
    customerID: state.createNewUserRed.customerID, //todo: we may not need this
    customerSubscription: state.createNewUserRed.customerSubscription, //todo: we may not need this either
});

const mapDispatchToProps = ( dispatch ) => ({
    createNewUser: ( payload ) => {
        dispatch( createNewUser( payload ))
    },
    onExitClicked: ( ) => {
         dispatch( createNewUser ({
            status: 'cancelled'
        }));
    }
});

const AddUser = connect(
    mapStateToProps,
    mapDispatchToProps
) ( AddUserView );

export default AddUser;


/** WEBPACK FOOTER **
 ** ./src/components/User/AddUser.js
 **/